import IndexMenus from '../pages/IndexMenus.vue'

export default [
    {
        name: 'vendor.menu',
        path: '/vendor/menu',
        component: IndexMenus,
        meta: {
            layout: 'vendor'
        }
    }
]